module.exports = __webpack_public_path__ + "static/media/EmpanadaCebollin.b97e49dd.jpg";